import { Reveal, SectionLabel } from "../Reveal";
import { FALSE_BELIEFS, REVELATIONS, HOST } from "../../content";

export const Letter = () => (
  <section className="bg-white/[0.015] py-28 md:py-36 px-6" data-testid="letter-section">
    <div className="max-w-[760px] mx-auto">
      <Reveal><SectionLabel num="002" text="A LETTER FROM REGINALD" /></Reveal>
      <Reveal delay={0.05}>
        <p className="serif italic text-xl text-white mb-10">Veteran,</p>
        <p className="text-white text-[17px] leading-[1.8] mb-10">
          Three beliefs cost veterans the home they earned:
        </p>
      </Reveal>
      <div className="space-y-4 mb-12">
        {FALSE_BELIEFS.map((b, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <div
              className="flex gap-4 rounded-lg px-6 py-5"
              style={{ background: "rgba(255,0,0,0.04)", border: "1px solid rgba(255,0,0,0.1)" }}
              data-testid={`false-belief-card-${i}`}
            >
              <span className="text-[#FE0000] font-bold shrink-0">✗</span>
              <span className="serif italic text-[17px] text-white">{b}</span>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal><div className="h-px w-24 bg-[#FE0000] mb-12" /></Reveal>
      <div className="space-y-6">
        {REVELATIONS.map((p, i) => (
          <Reveal key={i} delay={i * 0.06}>
            <p className="text-white text-[17px] leading-[1.8]" data-testid={`revelation-paragraph-${i}`}>{p}</p>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.1}>
        <p className="mono text-sm text-[#FE0000] mt-12 tracking-wide" data-testid="letter-signoff">
          — {HOST.name}, {HOST.company}
        </p>
      </Reveal>
    </div>
  </section>
);
